import * as React from "react";
import { Search } from "lucide-react";
import { ShortcutManager } from "@authe/fe-commons/shortcuts";

const Palette = React.lazy(() => import("./HeaderSearchPalette").then((module) => ({ default: module.HeaderSearchPalette })));

/** Keep the entry path light; load search providers and results on first use. */
export function HeaderSearch(): React.ReactElement {
  const [open, setOpen] = React.useState(false);
  const [requested, setRequested] = React.useState(false);

  React.useEffect(() => {
    const manager = new ShortcutManager();
    manager.register({
      combo: "mod+k",
      description: "Open search",
      allowInInput: true,
      handler: () => { setRequested(true); setOpen((value) => !value); },
    });
    return manager.attach();
  }, []);

  return <>
    <button
      type="button"
      onClick={() => { setRequested(true); setOpen(true); }}
      className="flex h-9 w-full max-w-md items-center gap-2 rounded-md border border-border bg-muted/40 px-3 text-sm text-muted-foreground transition-colors hover:bg-muted"
    >
      <Search className="h-4 w-4 shrink-0" />
      <span className="min-w-0 flex-1 truncate text-left">Search…</span>
      <kbd className="hidden shrink-0 rounded border border-border bg-background px-1.5 text-[10px] font-medium sm:inline">⌘K</kbd>
    </button>
    {requested && <React.Suspense fallback={open ? <span role="status" className="sr-only">Opening search…</span> : null}>
      <Palette open={open} onOpenChange={setOpen} />
    </React.Suspense>}
  </>;
}
